const ALPHABET = 'ABCDEFGHJKLMNPQRSTUWXYZ';
const ALPHABET_LENGTH = ALPHABET.length;
export default function createOrderCodeHint() {
  return [...new Array(3)].map(() => ALPHABET[Math.floor(Math.random() * ALPHABET_LENGTH)]).join('') + Math.floor(Math.random() * 100);
}
